import createAPI from './hotel-api';

const credentialsConf = {
  withCredentials: true,
  validateStatus: () => true,
};

const api = createAPI(process.env.MUJI_APP_HOST, {
  showNotification: true,
});

export function generatePdf(id) {
  return api.getJson(`/portal/api/v2/pdf/generate/${id}`, {}, { ...credentialsConf, timeout: 30000 });
}

export function downloadPdf(id) {
  return api.getJson(`/portal/api/v2/pdf/download/${id}`, {}, { ...credentialsConf, timeout: 30000 });
}